<template>
  <div id="con">
    <el-carousel type="card" height="404px" class="pc">
      <el-carousel-item
        class="img"
        v-for="(x, i) in slideList"
        :key="i"
        v-bind:style="{ backgroundImage: 'url(' + x.path + ')' }"
      >
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="150px" class="phone" indicator-position="none">
      <el-carousel-item
        class="img"
        v-for="(x, i) in slideList"
        :key="i"
        v-bind:style="{ backgroundImage: 'url(' + x.path + ')' }"
      >
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<style scoped>
#con {
  width: 100%;
  background-color: #ffffff;
}
.img {
  background-position: center;
  background-size: cover;
}
.phone {
  display: none;
}
.pc {
  display: inherit;
}
@media screen and (max-width: 600px) {
  .el-carousel {
    width: 100%;
    height: 202px;
  }
  .phone {
    display: inherit;
    overflow: hidden;
  }
  .pc {
    display: none;
  }
}
</style>

<script>
import "element-ui/lib/theme-chalk/display.css";
export default {
  data() {
    return {
      slideList: [
        {
          path: require("@/assets/home/banner0.jpg"),
          content: ""
        },
        {
          path: require("@/assets/home/banner1.jpg"),
          content: ""
        },
        {
          path: require("@/assets/home/banner2.jpg"),
          content: ""
        },
        {
          path: require("@/assets/home/banner3.jpg"),
          content: ""
        },
        {
          path: require("@/assets/home/banner4.jpg"),
          content: ""
        },
        {
          path: require("@/assets/home/banner5.jpg"),
          content: ""
        }
      ]
    };
  }
};
</script>
